<template>
  <v-menu
    attach
    content-class="tender-card-options-menu "
    left
    offset-x
    offset-y>
    <template #activator="{ on }">
      <div
        v-on="on"
        @click.prevent="">
        <sButton
          v-if="$acl.check('onlyTenders') || element.tenderStatusId > 1 "
          data-qa="btn-action-lest-menu"
          icon="menu"
          small
          type="text"/>
      </div>
    </template>
    <v-list
      class="tender-card-menu menu"
      dense>
      <template v-if="$acl.check('onlyTenders')">
        <CopyTender
          list
          :tender="element"
          without-bid/>
        <template v-if="!element.hasRoute && !not_editing">
          <ReturnToRegistrationConfirmation :item="element"/>
          <DeleteTender
            list
            :tender="element"/>
        </template>
      </template>
      <ToggleTemplates
        :add="!element.isTemplate"
        list
        @click="toTemplate"/>
      <DownloadComparisonTable
        v-if="element"
        list
        :tender="element"/>
    </v-list>
  </v-menu>
</template>
<script>
import CopyTender from 'components/tenders/dialogs/CopyTender.vue'
import DeleteTender from 'components/tenders/dialogs/DeleteTender.vue'
import ToggleTemplates from 'components/common/elements/ToggleTemplates.vue'
import DownloadComparisonTable from 'components/tenders/tender page/DownloadComparisonTable.vue'
import ReturnToRegistrationConfirmation from 'components/tenders/dialogs/ReturnToRegistrationConfirmation.vue'

import { tenderMixin } from 'mixins'

export default {
  name: 'tenderActionsList',
  mixins: [tenderMixin],
  props: {
    element: {
      type: Object,
      default: () => {}
    },
    not_editing: Boolean
  },
  methods: {
    toTemplate() {
      this.toggleTemplateInMainPage(this.element)
    }
  },
  components: {
    CopyTender,
    DeleteTender,
    ToggleTemplates,
    DownloadComparisonTable,
    ReturnToRegistrationConfirmation
  }
}
</script>
